import styled from "styled-components";

export const Container = styled.div`
    strong, p {
        font-family: UOLText, Arial, Helvetica, sans-serif;
    }
`;